import { Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { State } from '../../store/main';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Login } from '../../store/auth/actions';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent {
  public loading = false;
  public loginDone$ = new BehaviorSubject<boolean | undefined>(undefined);
  public error$ = new BehaviorSubject<string | undefined>(undefined);
  // form
  public loginForm = new FormGroup({
    email: new FormControl('', {
      validators: [Validators.required, Validators.email],
    }),
    password: new FormControl('', {
      validators: [Validators.minLength(8)],
    }),
  });

  constructor(private router: Router, private store: Store<State>) {
    this.store
      .pipe(select('auth'))
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (authState) => {
          if (authState.error) this.loading = false;
          this.error$.next(authState.error);

          if (authState.isAuthenticated) {
            let redirectTo = '/run-management';
            const { queryParams } = this.router.routerState.snapshot.root;

            if (queryParams && queryParams.from) {
              redirectTo = decodeURI(queryParams.from);
            }
            this.router.navigateByUrl(redirectTo);
          }
        },
      });
  }

  public onLoginSubmit() {
    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;
    this.handleLogin();
  }

  public handleLogin() {
    const formValues = this.loginForm.value;
    this.store.dispatch(
      new Login({
        alias: formValues.email,
        password: formValues.password,
        rememberFor: 0,
      }),
    );
  }

  /**
   * UI event callbacks
   */
  public onErrorAlertClose() {
    // this.store.dispatch(new ClearUpdateUser());
  }

  public onSuccessAlertClose() {}
}
